import { IonPage } from "@ionic/react";
import { ReactNode, RefObject, useContext } from "react";
import { Helmet } from "react-helmet-async";
import { useIntl } from "react-intl";

import Banner from "@components/banners/Banner";
import AppPageWithMenu from "@components/pageTypes/AppPageWithMenu";
import styles from "@components/pageTypes/Page.module.css";
import PageTitle, { UsableImageName } from "@components/text/PageTitle";
import { bannerContext } from "@context/Contexts";

type Props = {
  children: ReactNode;
  contentRef?: RefObject<HTMLIonContentElement>;
  helmetKey: string;
  imageName: UsableImageName | null;
  journeyId: string;
  title?: string;
  titleKey: string | null;
};

const ExpertJourneyTablesPage = ({ children, contentRef, helmetKey, imageName, journeyId, title, titleKey }: Props) => {
  const intl = useIntl();
  const { currentBanner } = useContext(bannerContext);

  return (
    <AppPageWithMenu contentRef={contentRef} journeyId={journeyId}>
      <Helmet>
        <title>{intl.formatMessage({ id: helmetKey })}</title>
      </Helmet>
      {currentBanner && <Banner banner={currentBanner} />}
      <IonPage className={`${styles.tablePageContainer} ${currentBanner ? styles.bannerSpacing : ""}`}>
        {imageName && (titleKey || title) && (
          <div className={styles.tablePageTitle}>
            <PageTitle imageName={imageName} title={title} titleKey={titleKey} />
          </div>
        )}
        {children}
      </IonPage>
    </AppPageWithMenu>
  );
};

export default ExpertJourneyTablesPage;
